import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { startRegisterSearchInfo } from "../../app/actions/searchInfoActions";
import { setPreviousSearchParams } from "../../app/actions/searchHistoryActions";
import { dispatchModulePaginatedSearch } from "../../app/helpers/moduleSearch.helper";

const FILTER_CIIUS = "catalogciiu_levels";
const FILTER_SECTIONS = "catalogsection_levels";
const FILTER_PHASES = "catalogphase_levels";

const FILTER_INSTITUTIONS = "cataloginstitution_levels";

const CheckListOptionsCatalogStateMulti = ({
  dataList,
  title,
  keyCatalog,
  searchTextState,
  catalogsToFilter,
  setCatalogsToFilter,
  itemsPerPage,
  setItemsPerPage,
  moduleSelected,
  catalogCiiuLevel1Selected,
  indicatorsToFilter,
  setIndicatorsToFilter,
  groupVisionSelected
}) => {
  const dispatch = useDispatch();

  const [checkboxes, setCheckboxes] = useState(dataList);
  const [checkboxesHist, setCheckboxesHist] = useState([]);

  const { user } = useSelector((state) => state.auth);

  useEffect(() => {

    const indexForConsider = catalogsToFilter.findIndex((item) => item.hasOwnProperty(keyCatalog));
    if (catalogsToFilter && catalogsToFilter.length > 0 && indexForConsider !== -1) {

      if (dataList && dataList.length > 0) {

        let checkboxesHistChecked = {};
        if (checkboxesHist && checkboxesHist.length > 0) {

          checkboxesHistChecked = checkboxesHist.find((itemHist) => itemHist.isChecked);

          if (checkboxesHistChecked && Object.keys(checkboxesHistChecked).length > 0) {

            let dataListHist = [...dataList];

            let dataListHistChecked = dataListHist.find((itemDataListChecked) => itemDataListChecked.code === checkboxesHistChecked.code);

            if (dataListHistChecked && Object.keys(dataListHistChecked).length > 0) {

              dataListHistChecked.isChecked = true;

              setCheckboxes([dataListHistChecked]);
            } else {

            }
          } else {

          }
        } else {

          setCheckboxes(dataList);
        }
      } else {

      }
    } else {

      setCheckboxes(dataList);
    }

  }, [dataList, catalogsToFilter])

  const setCatalogToFilter = (code, dataListLocal) => {

    let catalogsToFilterList = [];
    catalogsToFilterList = [...catalogsToFilter];

    let catalogOptionToFilterObjet = {};

    switch (keyCatalog) {
      case FILTER_CIIUS:
        catalogOptionToFilterObjet = {

          catalogciiu_levels: code
        };
        break;

      case FILTER_SECTIONS:
        catalogOptionToFilterObjet = {

          catalogsection_levels: code
        };
        break;

      case FILTER_PHASES:
        catalogOptionToFilterObjet = {

          catalogphase_levels: code
        };
        break;

      case FILTER_INSTITUTIONS:
        catalogOptionToFilterObjet = {

          cataloginstitution_levels: code
        };
        break;

      /*
    case FILTER_WORRIES:
      catalogOptionToFilterObjet = {
        
        worry_ids: id,
      };
      break;

    case FILTER_TOPICS:
      catalogOptionToFilterObjet = {
        
        topics_ids: id,
      };
      break;

    case FILTER_THEMES:
      catalogOptionToFilterObjet = {
        
        themes_ids: id,
      };
      break;
      */

      default:
        catalogOptionToFilterObjet = {
          [keyCatalog]: code,
        };
        break;
    }

    const catalog_id_object =
      catalogsToFilterList &&
      catalogsToFilterList.length > 0 &&
      catalogsToFilterList.find((element) =>
        element.hasOwnProperty(keyCatalog)
      );

    if (!catalog_id_object) {

      setCheckboxesHist(dataListLocal);

      catalogsToFilterList.push(catalogOptionToFilterObjet);
      setCatalogsToFilter(catalogsToFilterList);

      /*******> SEARCH_INFO <*******/

      const searchInfo = {
        text_search: searchTextState,
        indicators: indicatorsToFilter,
        filters: catalogsToFilterList,

        catalogmodule_id: moduleSelected.id,
        user_id: user.user_id,

        deleted: false
      }

      dispatch(startRegisterSearchInfo(searchInfo));

      //JT PAGE
      dispatch(setPreviousSearchParams({
        searchText: searchTextState,
        page: 0,
        catalogsToFilter: catalogsToFilterList,
        indicatorsToFilter: indicatorsToFilter,
        //moduleKey: moduleSelected?.key,
        //catalogModuleId: moduleSelected?.id,
        catalogModule: moduleSelected ? moduleSelected : {},
        catalogCiiuLevel1: catalogCiiuLevel1Selected ? catalogCiiuLevel1Selected : {},
        groupVision: groupVisionSelected ? groupVisionSelected : {}
      }));

      // Preparas los parámetros
      const searchParams = {
        searchText: searchTextState,
        moduleKey: moduleSelected?.key,
        page: 0,
        itemsPerPage: itemsPerPage,
        catalogsToFilter: catalogsToFilterList,
        indicatorsToFilter: indicatorsToFilter,
        codeCiiuLevel1: catalogCiiuLevel1Selected?.code || null
      };

      // Ejecutas el helper genérico
      dispatchModulePaginatedSearch(dispatch, searchParams);

    }

  };

  const handleChangeCheckbox = (event, code) => {

    let dataListLocal = [...dataList];

    dataListLocal = checkboxes.map((checkbox) =>
      checkbox.code === code ? { ...checkbox, isChecked: true } : checkbox
    )

    setCheckboxes(checkboxes.map((checkbox) =>
      checkbox.code === code ? { ...checkbox, isChecked: true } : checkbox
    ));

    setCatalogToFilter(code, dataListLocal);

  }

  return (
    <div>
      <div className="option-title">{/*title*/}</div>
      <ul className="toppings-list">
        {checkboxes.map(({ name, description, id, isChecked, code }, index) => {
          return (
            <li key={index}>
              <div className="toppings-list-item">
                <div className="left-section">
                  <input
                    type="checkbox"
                    id={`custom-checkbox-${index}`}
                    checked={isChecked}
                    name={name}
                    value={name}
                    onChange={(event) => handleChangeCheckbox(event, code)}
                  />
                  <label
                    htmlFor={`custom-checkbox-${index}`}
                    style={{ display: "inline" }}
                  >
                    {name}
                  </label>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CheckListOptionsCatalogStateMulti;